import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Helmet } from "react-helmet";

import ChatbotPopup from "../components/ChatbotPopup";
import Error from "../components/Error";
import InnerBlocks from "../components/InnerBlocks";
import Base from "../templates/base";
import axios from "axios";
import { Config } from "../config";

@inject("PageStore")
@inject("AppStore")
@observer
class Page extends Component {
  state = {
    currentUrl: "",
    canonicalUrl: "",
    metaDescription: "",
    acfTitle: "",
    altLangs: []
  };

  UNSAFE_componentWillMount() {
    this.populatePage();
    this.setDocumentHead();
  }

  componentDidUpdate(curr, prev) {
    if (this.state.currentUrl !== prev.currentUrl) {
      this.populatePage();
      this.setDocumentHead();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.setState({ currentUrl: nextProps.location.pathname });
    }
  }

  setDocumentHead = () => {
    const href = window.location.href.split("/");
    let slug = href[href.length - 1];
    slug = slug ? slug : "more-than-height";
    if (slug === "ar") slug = "more-than-height";

    const endpoint = `${Config.endpoint.wordpress.base}${Config.endpoint.wordpress.wp}${Config.endpoint.wordpress.pages}?slug=${slug}`;
    axios.get(endpoint).then(response => {
      if (response.data[0]) {
        const acfTitle = response.data[0].acf.page_title;
        const acfMetaDescription = response.data[0].acf.meta_desc;
        const acflinkCanonical = response.data[0].acf.canonical_link;
        const altLangEnLink = response.data[0].acf.alt_lang_en_link ? response.data[0].acf.alt_lang_en_link : "";
        const altLangEsLink = response.data[0].acf.alt_lang_es_link ? response.data[0].acf.alt_lang_es_link : "";
        const altLangFrLink = response.data[0].acf.alt_lang_fr_link ? response.data[0].acf.alt_lang_fr_link : "";
        const altLangArLink = response.data[0].acf.alt_lang_ar_link ? response.data[0].acf.alt_lang_ar_link : "";

        this.setState({
          canonicalUrl: `${process.env.REACT_APP_SITE_URL}/${acflinkCanonical}`,
          metaDescription: acfMetaDescription,
          acfTitle: acfTitle,
          altLangFrLink: altLangFrLink,
          altLangEnLink: altLangEnLink,
          altLangArLink: altLangArLink,
          altLangEsLink: altLangEsLink
        });
      }
    });
  };

  populatePage = () => {
    const {
      PageStore: { populate },
      AppStore: { populate: appPopulate }
    } = this.props;

    appPopulate(this.props.match);
    populate(this.props);
  };

  render() {
    const {
      PageStore: { data }
    } = this.props;
    const {
      AppStore: {
        data: { colorScheme, env }
      }
    } = this.props;
    return (
      <>
        <Helmet>
          <title>{this.state.acfTitle}</title>
          <meta name="description" content={this.state.metaDescription}></meta>
          <link rel="canonical" href={this.state.canonicalUrl} />
          <link rel="alternate" href={process.env.REACT_APP_EN_URL + '/' + this.state.altLangEnLink} hreflang="en-gb" />
          <link rel="alternate" href={process.env.REACT_APP_EN_URL + '/' + this.state.altLangEnLink} hreflang="en-us" />
          <link rel="alternate" href={process.env.REACT_APP_EN_URL + '/' + this.state.altLangEnLink} hreflang="en-ca" />
          <link rel="alternate" href={process.env.REACT_APP_ES_URL + '/' + this.state.altLangEsLink} hreflang="es-co" />
          <link rel="alternate" href={process.env.REACT_APP_ES_URL + '/' + this.state.altLangEsLink} hreflang="es-mx" />
          <link rel="alternate" href={process.env.REACT_APP_ES_URL + '/' + this.state.altLangEsLink} hreflang="es-ar" />
          <link rel="alternate" href={process.env.REACT_APP_FR_URL + '/' + this.state.altLangFrLink} hreflang="fr-fr" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-sa" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-qa" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-om" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-bh" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-kw" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-lb" />
          <link rel="alternate" href={process.env.REACT_APP_AR_URL + '/' + this.state.altLangArLink} hreflang="ar-dz" />
        </Helmet>
        <div id="main" data-colorscheme={colorScheme} data-env={env}>
          <Base>
            <article className="grid">
              <div className="page_content">
                {data && <InnerBlocks blocks={data} />}
                {!data && <Error />}
              </div>
            </article>
            {process.env.REACT_APP_LANG !== 'ar-ar' && <ChatbotPopup />}
          </Base>
        </div>
      </>
    );
  }
}

export default Page;
